import { restApi } from '../../api/restApiSlice';

const api = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getPhoneNumber: builder.query({
      query: () => ({
        url: '/v3/my-account/my-phone',
        method: 'GET',
      }),
      transformErrorResponse: (response) => response.data,
      providesTags: ['UserPhoneNumber'],
    }),
    getCommsConsent: builder.query({
      query: () => ({
        url: '/v3/my-account/comms-consent',
        method: 'GET',
      }),
      transformErrorResponse: (response) => response.data,
      providesTags: ['CommsConsent'],
    }),
    setMarketingConsent: builder.mutation({
      query: ({ marketing }) => ({
        url: '/v3/my-account/comms-consent',
        method: 'PATCH',
        body: { marketing },
      }),
      transformErrorResponse: (response) => response.data,
      invalidatesTags: ['CommsConsent'],
    }),
    setAdminEmail: builder.mutation({
      query: ({ adminEmail, companyName }) => ({
        url: '/v3/my-account/admin-email',
        method: 'POST',
        body: { adminEmail, companyName },
      }),
      transformErrorResponse: (response) => response.data,
    }),
    setUserDetails: builder.mutation({
      query: ({ email, firstName, lastName, phoneNumber }) => ({
        url: '/v3/my-account/user-details',
        method: 'POST',
        body: { email, firstName, lastName, phoneNumber: phoneNumber?.length > 0 ? phoneNumber : null },
      }),
      transformErrorResponse: (response) => response.data,
      invalidatesTags: ['UserPhoneNumber'],
    }),
  }),
});

export const {
  useSetAdminEmailMutation,
  useSetUserDetailsMutation,
  useGetPhoneNumberQuery,
  useGetCommsConsentQuery,
  useSetMarketingConsentMutation,
} = api;
